import { createApp } from "vue";

import { decodeUrlMixin } from "./mixins/decode-url.mixin";

import App from "./App.vue";

const app = createApp(App);

app.mixin(decodeUrlMixin);

import installI18n from "./i18n";
import installVueLoading from "./plugins/vue-loading-overlay";
import installVueVirtualScroller from "./plugins/vue-virtual-scroller";
import veeValidatePlugin from "./plugins/vee-validate";
import urlQueryMixin from "./mixins/url-query.mixin"; // Import mixin

// Register plugins for vue
installI18n(app);
installVueLoading(app);
installVueVirtualScroller(app);

import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import { loadFonts } from "./plugins/webfontloader";
loadFonts();

app.mixin(urlQueryMixin as any);
app.use(router).use(store).use(vuetify).use(veeValidatePlugin).mount("#app");

export default app;
